import { useCallback, useState } from 'react';
import Navbar from '@components/landing/Navbar';
import Hero from '@components/landing/Hero';
import Features from '@components/landing/Features';
import Services from '@components/landing/Services';
import Audience from '@components/landing/Audience';
import PodusFeatures from '@components/landing/PodusFeatures';
import Glimpse from '@components/landing/Glimpse';
import Regions from '@components/landing/Regions';
import Testimonials from '@components/landing/Testimonials';
import FAQ from '@components/landing/FAQ';
import SingleSignIn from '@components/landing/SingleSignIn';
import { LandingPagesFooter as Footer } from '@podus/ui';
import { LanguageProvider } from '@/i18n/LanguageContext';
import Preloader from '@components/landing/Preloader';

export default function Home() {
    const [loading, setLoading] = useState(true);
    const [entered, setEntered] = useState(false);

    const handlePreloaderComplete = useCallback(() => {
        setLoading(false);
        requestAnimationFrame(() => {
            requestAnimationFrame(() => setEntered(true));
        });
    }, []);

    return (
        <LanguageProvider>
            {loading && <Preloader onComplete={handlePreloaderComplete} />}
            <div className="page-scroll-root bg-white">
                <Navbar />
                <main className="mx-auto max-w-[1920px] pb-4 pt-[10px] lg:pb-0">
                    <div
                        style={{
                            opacity: entered ? 1 : 0,
                            transform: entered ? 'translateY(0)' : 'translateY(60px)',
                            transition:
                                'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
                        }}
                    >
                        <Hero />
                    </div>
                    <Features />
                    <Services />
                    <SingleSignIn />
                    <PodusFeatures />
                    <Glimpse />
                    <Regions />
                    <Audience />
                    <Testimonials />
                    <FAQ />
                </main>
                <div className="mx-auto">
                    <Footer />
                </div>
            </div>
        </LanguageProvider>
    );
}
